import { useQuery, UseQueryResult } from 'react-query';
import { useAppSelector } from '@/hooks/redux';
import { conflictService, UserConflicts } from '@/services/conflictService';

/**
 * Shared hook for org-level conflict data.
 * Used by both DashboardPage (for conflict count) and WeeklyCalendar (for conflict indicators).
 * Uses a stable query key so both consumers share the same cache entry.
 */
export function useOrgConflicts(enabled = true): UseQueryResult<UserConflicts> {
  const orgId = useAppSelector((state) => state.auth.user?.currentOrganizationId);

  return useQuery(
    ['conflicts', orgId],
    () => conflictService.getConflicts(),
    {
      enabled: enabled && !!orgId,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    }
  );
}
